import logo from '../assets/images/logos/logo-long-transparent.svg';

const LoaderFull = () => {
    return (
        <div className="loader-full">
            <div className="loader-container">
                <img src={logo} className="loader-logo" alt="logo" />
            </div>
        </div>
    );
}

export default LoaderFull;